import classNames from "classnames";
import React, { useEffect } from "react";

interface CheckboxProps {
  autoFocus?: boolean;
  keyboardNavigationOptions?: Record<string, any>;
  className?: string;
  label?: React.ReactNode;
  checked: boolean;
  error?: boolean;
  disabled?: boolean;
  onChange: (event: React.ChangeEvent, value: boolean) => void;
  onClick?: React.MouseEventHandler<HTMLInputElement>;
}

export const Checkbox = ({ autoFocus, keyboardNavigationOptions = {}, className, error, label, checked, disabled, onChange, onClick }: CheckboxProps) => {
  const inputRef = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current && autoFocus) {
      inputRef.current.focus();
    }
  }, []);

  return <label className={classNames("checkbox-radio-with-label", {
    "checkbox-radio-with-label-error": error,
  })}>
    <input
      ref={inputRef} {...keyboardNavigationOptions}
      tabIndex={0}
      className={className}
      onChange={(e) => onChange(e, !checked)}
      onClick={onClick}
      type="checkbox"
      disabled={disabled}
      checked={checked}
    />
    {label}
  </label>
}

